
import image from "../../../images/carouselImages/home/A2.webp";
import image2 from "../../../images/carouselImages/home/A1.webp";

const testimonials = [
  {
    id: 1,
    image: image,
    name: "Francois Verschueren",
    dateAndPlace: "31/08/2023 | Etikhove",
    subject: "Interieur",
    quote:
      "Aangenaam en professioneel gesprek .. goed advies Een faire prijsofferte.",
    rating: 5,
    url: "referentie/id:1",
  },
  {
    id: 2,
    image: image2,
    name: "Shirley",
    dateAndPlace: "16/04/2023 | Beveren-leie",
    subject: "Interieur",
    quote:
      "Super tevreden! Onze volledige benedenverdieping werd tot in de puntjes afgewerkt! Heel, mooi werk. Ons huis werd netjes achtergelaten zonder dat wij zelf nog moesten gaan opruimen. Sterke aanrader!",
    rating: 5,
    url: "referentie/id:1",
  },
  {
    id: 3,
    image: image,
    name: "Van Maldeghem Sandrine",
    dateAndPlace: "24/04/2023 | Harelbeke",
    subject: "Behangen",
    quote:
      "Alexandro is een TOPKEREL, steeds behulpzaam,heeft oog voor detail,werkt met precizie,steeds vriendelijk, komt zijn beloftes na en zijn werk is zeker naar behoren gedaan en prachtig afgewerkt. Wij zijn heel tevreden met het resultaat en hij mag de rest van onze woning komen afwerken zoals beloofd.",
    rating: 5,
    url: "referentie/id:1",
  },
  {
    id: 4,
    image: image,
    name: "Sabrina Bekaert",
    dateAndPlace: "23/04/2023 | Bissegem",
    subject: "Exterieur",
    quote:
      "Heel tevreden van het geleverde werk en advies inzake kleuren en er wordt gewerkt met de topprodukten van Boss.Er wordt proper gewerkt en ook opgekuist.Volgende project staat al vast 🙂Er wordt proper gewerkt en ook opgekuist.Volgende project staat al vast 🙂 ",
    rating: 5,
    url: "referentie/id:1",
  },
  {
    id: 5,
    image: image,
    name: "Kris Vandoorne",
    dateAndPlace: "23/04/2023 | Kortrijk",
    subject: "Interieur",
    quote:
      "Heel tevreden van het werk. fijne afwerking en alles correct verlopen. Zeker een aanrader 👌👌 ",
    rating: 5,
    url: "referentie/id:1",
  },
  {
    id: 6,
    image: image,
    name: "Eddy syx",
    dateAndPlace: "18/05/2023 | Harelbeke",
    subject: "Aqua-Sensa",
    quote:
      "Topwerk. Een jonge gast die zich aan zijn beloftes houd en betaalbaar. Hij heeft onze veranda onder handen genomen en we waren verbluft van zijn capaciteiten en het resultaat. Volgend jaar mag hij de rest van ons huis afwerken. Heel tevreden.",
    rating: 5,
    url: "referentie/id:1",
  },
];

export default testimonials;
